// Moxi · Mega Menu — hover + accesibilidad
(() => {
  if (window.__moxMegaInit) return;
  window.__moxMegaInit = true;

  const root = document.querySelector('.hdt-section-header');
  if (!root) return;

  const OPEN_CLASS   = 'is-open';
  const ENTER_DELAY  = 20;   // ms
  const LEAVE_DELAY  = 120;  // ms

  function open(details, summary) {
    details.classList.add(OPEN_CLASS);
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function close(details, summary) {
    details.classList.remove(OPEN_CLASS);
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  root.querySelectorAll('[data-mox-details]').forEach((details) => {
    const summary = details.querySelector('summary');
    const panel   = details.querySelector('.mox-mega');

    if (!summary || !panel) return;

    let enterT = 0;
    let leaveT = 0;

    // ✅ PRIMERA CLAVE: en desktop dejamos el <details> siempre "open"
    // para evitar el bug de que la primera vez necesite click.
    const isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isHoverDevice && !details.hasAttribute('open')) {
      details.setAttribute('open', 'true');
      // visualmente sigue "cerrado" porque CSS base tiene opacity:0 / pointer-events:none
      summary.setAttribute('aria-expanded', 'false');
    }

    // Hover: abre/cierra siempre con animación
    function onEnter() {
      clearTimeout(leaveT);
      enterT = window.setTimeout(() => open(details, summary), ENTER_DELAY);
    }

    function onLeave() {
      clearTimeout(enterT);
      leaveT = window.setTimeout(() => close(details, summary), LEAVE_DELAY);
    }

    summary.addEventListener('mouseenter', onEnter);
    summary.addEventListener('mouseleave', onLeave);
    panel.addEventListener('mouseenter', onEnter);
    panel.addEventListener('mouseleave', onLeave);

    // Teclado: ArrowDown abre, Esc cierra
    summary.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(details, summary);
        panel.querySelector('a')?.focus();
      }
      if (e.key === 'Escape') {
        close(details, summary);
        summary.focus();
      }
    });

    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        close(details, summary);
        summary.focus();
      }
    });

    // Click: solo sincronizamos aria, no molestamos el comportamiento nativo.
    summary.addEventListener('click', () => {
      requestAnimationFrame(() => {
        const isOpen = details.hasAttribute('open');
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  });
})();


